import { Link } from "react-router-dom";

/**
 * Traeva wordmark — two-colour split: Trae · va · ·
 *
 * Light variant (on paper/cream): Trae ink   · va navy-mid · dot coral
 * Dark  variant (on navy/ink):    Trae white · va coral    · dot coral
 */
export default function Logo({ size = "md", to = "/", variant = "light" }) {
  const sizes = {
    sm: "text-xl",
    md: "text-[26px]",
    lg: "text-5xl",
    xl: "text-7xl",
  };

  const colors = variant === "dark"
    ? { trae: "text-white", va: "text-coral", dot: "bg-coral" }
    : { trae: "text-ink",   va: "text-navy-mid", dot: "bg-coral" };

  return (
    <Link
      to={to}
      data-testid="logo"
      className={`inline-flex items-start leading-none select-none ${sizes[size]}`}
    >
      <span className={`font-serif-i ${colors.trae}`}>Trae</span>
      <span className={`font-serif-i ${colors.va}`}>va</span>
      <span
        aria-hidden="true"
        className={`ml-1 mt-1 w-1.5 h-1.5 rounded-full inline-block shrink-0 ${colors.dot}`}
      />
    </Link>
  );
}
